import httpExpertClient from '@/plugins/httpExpertClient';

export default {
  getMarks(id) {
    return httpExpertClient.get(`expert/compete/projects/${id}/marks`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/expertApis/compete/marksApis.js